import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateModule } from "@ngx-translate/core";
import { LitusAppProMaterialModule } from "../../modules/material.module";
import { PageHeaderComponent } from "./page-header/page-header.component";
import { AppDialogComponent } from "./app-dialog/app-dialog.component";
import { GroupByPipe } from "../../pipes/group-by.pipe";
import { CallbackPipe } from "../../pipes/callback.pipe";

@NgModule({
  imports: [
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    LitusAppProMaterialModule,
    TranslateModule,
  ],
  exports: [
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    LitusAppProMaterialModule,
    TranslateModule,
    GroupByPipe,
    CallbackPipe,
    PageHeaderComponent,
    AppDialogComponent,
  ],
  declarations: [
    GroupByPipe,
    CallbackPipe,
    PageHeaderComponent,
    AppDialogComponent,
  ],
  entryComponents: [AppDialogComponent],
})
export class SharedModule {}
